<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-09-20 09:19:56
 * @LastEditTime: 2019-09-20 13:28:04
 * @LastEditors: Please set LastEditors
 -->
<template>
    <div id="page_Container">
        <!-- <navigation title="付款成功" :left-arrow="true"/> -->
        <div class='content'>
           <div id='main-container' class="main-container">
            <img src="../assets/img/goods/payfail.png" alt="">
            <div class="suctip1">支付失败</div>
            <div class="suctip2">哎呀呀是什么原因呢～</div>
            <div class="returnbtn" @click="gohome">返回主页</div>
           </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
        };
    },
    esvReady: function() {
        document.title = '付款失败';
    },
    methods: {
        gohome() {
            const ths = this;
            ths.esvOpenPage('OPHomenew');
            // ths.esvReloadPage('OPHomenew');
        }
    }
};
</script>
<style lang="scss" scoped>
.content{
    margin-top: 30px;
    text-align: center;
    img{
        width: 65px;
        height: 65px;
    }
    .suctip1{
        color: #333;
        font-size: 20px;
        margin-top: 16px;
        margin-bottom: 8px;
    }
    .suctip2{
        color: #999;
        font-size: 14px;
    }
    .returnbtn{
        width: 87%;
        height: 44px;
        line-height: 44px;
        color: #fff;
        font-size: 14px;
        background: $primary-color;
        border-radius: 22px;
        margin: 56px auto 0;
    }
}
</style>
